/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskMetric } from './RiskMetric';
import { RiskMetricFromJSON, RiskMetricFromJSONTyped, RiskMetricToJSON } from './RiskMetric';

/**
 *
 * @export
 * @interface RiskMetricResult
 */
export interface RiskMetricResult {
  /**
   *
   * @type {number}
   * @memberof RiskMetricResult
   */
  readonly id: number;
  /**
   *
   * @type {RiskMetric}
   * @memberof RiskMetricResult
   */
  readonly metric: RiskMetric;
  /**
   *
   * @type {number}
   * @memberof RiskMetricResult
   */
  value: number;
  /**
   *
   * @type {number}
   * @memberof RiskMetricResult
   */
  confidenceLow?: number | null;
  /**
   *
   * @type {number}
   * @memberof RiskMetricResult
   */
  confidenceHigh?: number | null;
  /**
   *
   * @type {number}
   * @memberof RiskMetricResult
   */
  drift?: number | null;
  /**
   *
   * @type {string}
   * @memberof RiskMetricResult
   */
  readonly assessmentId: string;
  /**
   *
   * @type {string}
   * @memberof RiskMetricResult
   */
  comment?: string;
  /**
   *
   * @type {boolean}
   * @memberof RiskMetricResult
   */
  isApplicable?: boolean;
}

/**
 * Check if a given object implements the RiskMetricResult interface.
 */
export function instanceOfRiskMetricResult(value: object): value is RiskMetricResult {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('metric' in value) || value['metric'] === undefined) return false;
  if (!('value' in value) || value['value'] === undefined) return false;
  if (!('assessmentId' in value) || value['assessmentId'] === undefined) return false;
  return true;
}

export function RiskMetricResultFromJSON(json: any): RiskMetricResult {
  return RiskMetricResultFromJSONTyped(json, false);
}

export function RiskMetricResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskMetricResult {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    metric: RiskMetricFromJSON(json['metric']),
    value: json['value'],
    confidenceLow: json['confidence_low'] == null ? undefined : json['confidence_low'],
    confidenceHigh: json['confidence_high'] == null ? undefined : json['confidence_high'],
    drift: json['drift'] == null ? undefined : json['drift'],
    assessmentId: json['assessment_id'],
    comment: json['comment'] == null ? undefined : json['comment'],
    isApplicable: json['is_applicable'] == null ? undefined : json['is_applicable'],
  };
}

export function RiskMetricResultToJSON(value?: Omit<RiskMetricResult, 'id' | 'metric' | 'assessmentId'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    value: value['value'],
    confidence_low: value['confidenceLow'],
    confidence_high: value['confidenceHigh'],
    drift: value['drift'],
    comment: value['comment'],
    is_applicable: value['isApplicable'],
  };
}
